import {FormattedMessage, useIntl} from 'react-intl'
import {Parcel} from '../../core/_models/_parcels-models'
import {ParcelStatusItem} from './ParcelStatusItem'
import {useQuery} from 'react-query'
import {getParcelStatuses} from '../../core/_requests'
import {CParcelStatusItem} from './CParcelStatusItem'

interface Props {
  parcel: Parcel
}

export function ParcelStatus({parcel}: Props) {
  const {status_logs} = parcel
  const intl = useIntl()
  const {data: parcelStatuses} = useQuery(
    ['parcelStatuses', intl.locale, parcel.id],
    () => {
      return getParcelStatuses(parcel.id)
    },
    {keepPreviousData: true, retry: false}
  )
  return (
    <div className='card mb-5 mb-xl-10 pt-10'>
      <div className='card-body py-9 px-20  cardBody'>
        <div className='table-responsive'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold text-muted'>
                <th className='min-w-190px'>
                  <FormattedMessage id='PARCELS.P_PAGE.STATUSES.DATE_COLUMN' />
                </th>
                <th className='min-w-120px'>
                  <FormattedMessage id='PARCELS.P_PAGE.STATUSES.STATUS_COLUMN' />
                </th>
                <th className='min-w-100px '>
                  <FormattedMessage id='PARCELS.P_PAGE.STATUSES.AUTHOR_COLUMN' />
                </th>
              </tr>
            </thead>

            <tbody>
              {parcelStatuses?.statusLogs?.length &&
                parcelStatuses.statusLogs?.map((item: any, index: number) => (
                  <CParcelStatusItem key={index} log={item} />
                ))}
              {!parcelStatuses?.statusLogs?.length &&
                status_logs?.map((item) => <ParcelStatusItem key={item.id} log={item} />)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
